// SwapperContract ABI
export const SWAPPER_ABI = [
  "function swap(address tokenIn, address tokenOut, uint256 amountIn, uint256 amountOutMin, uint256 deadline) external payable",
  "function getQuote(address tokenIn, address tokenOut, uint256 amountIn) external view returns (uint256 amountOut, uint256 feeAmount)",
  "function FEE_PERCENTAGE() external view returns (uint256)",
  "function BASIS_POINTS() external view returns (uint256)",
  "function LIF3_TOKEN() external view returns (address)",
  "function LSHARE_TOKEN() external view returns (address)",
  "function uniswapRouter() external view returns (address)",
  "function WFTM() external view returns (address)",
  "function vault() external view returns (address)",
  "function owner() external view returns (address)",
  "function transferOwnership(address newOwner) external",
  "function pause() external",
  "function unpause() external",
  "function paused() external view returns (bool)",
  "function emergencyWithdraw(address token) external",
  "event SwapExecuted(address indexed user, address indexed tokenIn, address indexed tokenOut, uint256 amountIn, uint256 amountOut, uint256 feeAmount)",
  "event Paused(address account)",
  "event Unpaused(address account)"
];

// SwapperV2ContractFull ABI - handles V2 multi-DEX swaps with fee collection
export const SWAPPER_V2_ABI = [
  "function swapV2ExactTokensForTokens(address router, uint256 amountIn, uint256 amountOutMin, address[] path, uint256 deadline) external returns (uint256)",
  "function swapV2ExactETHForTokens(address router, uint256 amountOutMin, address[] path, uint256 deadline) external payable returns (uint256)",
  "function swapV2ExactTokensForETH(address router, uint256 amountIn, uint256 amountOutMin, address[] path, uint256 deadline) external returns (uint256)",
  "function swapV3ExactInput(address router, bytes path, uint256 amountIn, uint256 amountOutMinimum, uint256 deadline, bool isNativeOut) external payable returns (uint256)",
  "function FEE_PERCENTAGE() external view returns (uint256)",
  "function BASIS_POINTS() external view returns (uint256)",
  "function WFTM() external view returns (address)",
  "function vault() external view returns (address)",
  "function owner() external view returns (address)",
  "function setVault(address _vault) external",
  "function emergencyWithdraw(address token, uint256 amount) external",
  "event SwapExecuted(address indexed user, address indexed tokenIn, address indexed tokenOut, uint256 amountIn, uint256 amountOut, uint256 feeAmount)",
  "event VaultUpdated(address indexed oldVault, address indexed newVault)"
];

// Vault ABI
export const VAULT_ABI = [
  "function receiveFee(address token, uint256 amount) external payable",
  "function withdrawToken(address token, uint256 amount) external",
  "function withdrawNative(uint256 amount) external",
  "function getTokenBalance(address token) external view returns (uint256)",
  "function owner() external view returns (address)",
  "function swapperContract() external view returns (address)",
  "function setSwapperContract(address _swapper) external",
  "function transferOwnership(address newOwner) external",
  "function pause() external",
  "function unpause() external",
  "function paused() external view returns (bool)",
  "event FeeReceived(address indexed token, uint256 amount, address indexed from)",
  "event TokensWithdrawn(address indexed token, uint256 amount, address indexed to)",
  "event OwnershipTransferred(address indexed previousOwner, address indexed newOwner)",
  "event SwapperContractUpdated(address indexed oldSwapper, address indexed newSwapper)",
  "event Paused(address account)",
  "event Unpaused(address account)"
];

// ERC20 Token ABI
export const ERC20_ABI = [
  "function name() external view returns (string)",
  "function symbol() external view returns (string)",
  "function decimals() external view returns (uint8)",
  "function totalSupply() external view returns (uint256)",
  "function balanceOf(address owner) external view returns (uint256)",
  "function allowance(address owner, address spender) external view returns (uint256)",
  "function approve(address spender, uint256 value) external returns (bool)",
  "function transfer(address to, uint256 value) external returns (bool)",
  "function transferFrom(address from, address to, uint256 value) external returns (bool)",
  "event Transfer(address indexed from, address indexed to, uint256 value)",
  "event Approval(address indexed owner, address indexed spender, uint256 value)"
];

// WFTM ABI (extends ERC20)
export const WFTM_ABI = [
  ...ERC20_ABI,
  "function deposit() external payable",
  "function withdraw(uint256 amount) external",
  "event Deposit(address indexed dst, uint256 wad)",
  "event Withdrawal(address indexed src, uint256 wad)"
];

// Uniswap V2 Router ABI (partial)
export const UNISWAP_ROUTER_ABI = [
  "function factory() external pure returns (address)",
  "function WETH() external pure returns (address)",
  "function getAmountsOut(uint amountIn, address[] calldata path) external view returns (uint[] memory amounts)",
  "function getAmountsIn(uint amountOut, address[] calldata path) external view returns (uint[] memory amounts)",
  "function swapExactTokensForTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline) external returns (uint[] memory amounts)",
  "function swapExactETHForTokens(uint amountOutMin, address[] calldata path, address to, uint deadline) external payable returns (uint[] memory amounts)",
  "function swapExactTokensForETH(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline) external returns (uint[] memory amounts)",
  "function addLiquidity(address tokenA, address tokenB, uint amountADesired, uint amountBDesired, uint amountAMin, uint amountBMin, address to, uint deadline) external returns (uint amountA, uint amountB, uint liquidity)",
  "function addLiquidityETH(address token, uint amountTokenDesired, uint amountTokenMin, uint amountETHMin, address to, uint deadline) external payable returns (uint amountToken, uint amountETH, uint liquidity)"
];

// Uniswap V2 Factory ABI (partial)
export const UNISWAP_FACTORY_ABI = [
  "function getPair(address tokenA, address tokenB) external view returns (address pair)",
  "function allPairs(uint) external view returns (address pair)",
  "function allPairsLength() external view returns (uint)",
  "function createPair(address tokenA, address tokenB) external returns (address pair)"
];

// Uniswap V2 Pair ABI (partial)
export const UNISWAP_PAIR_ABI = [
  "function getReserves() external view returns (uint112 reserve0, uint112 reserve1, uint32 blockTimestampLast)",
  "function token0() external view returns (address)",
  "function token1() external view returns (address)",
  "function totalSupply() external view returns (uint256)",
  "function balanceOf(address owner) external view returns (uint256)"
];